<div class="modal-body">
    <div class="row mb-3">
        <div class="col-12 text-gris-oscuro fw-bold">
            <h4 class="mas-grande">Enviar prueba interna</h4>
        </div>
    </div>
    <form [formGroup]="formGroup">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label" for="cliente">Investigacion</label>
                    <input type="text" class="form-control disabled-fondo-blanco" id="cliente" placeholder="{{nombre}}">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label" for="pais">GrupoEnum</label>
                    <ng-select [items]="$any(grupos | async)" [clearable]="false" bindLabel="nombre" formControlName="grupo"
                        id="pais" ngDefaultControl></ng-select>
                </div>
            </div>
        </div>
    </form>
    <div class="row solo-botones">
        <div class="col-12 text-end">
            <button class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
            <button class="btn btn-primary" (click)="guardar()" [disabled]="formGroup.invalid">Guardar</button>
        </div>
    </div>
</div>
